import { render, staticRenderFns } from "./ShortMessager.vue?vue&type=template&id=7d0153db&"
import script from "./ShortMessager.vue?vue&type=script&lang=js&"
export * from "./ShortMessager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports